import React, { useEffect } from 'react';
import { redirect, useNavigate } from 'react-router-dom';

function WithAuth(props: any) {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  return <>{props.children}</>;
}

export default WithAuth;
